export interface ArticleMeta {
  id: string;
  titleKey: string;
  descKey: string;
  category: string;
  readTime: string;
  image: string;
}

export const articles: ArticleMeta[] = [
  {
    id: 'cssbuy-spreadsheet-guide',
    titleKey: 'article_spreadsheet_guide_title',
    descKey: 'article_spreadsheet_guide_desc',
    category: 'Guide',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=clean%20minimal%20desk%20with%20open%20laptop%20showing%20colorful%20spreadsheet%20and%20product%20photos%20on%20screen%20soft%20natural%20light%20warm%20neutral%20editorial&width=600&height=400&seq=art-guide&orientation=landscape',
  },
  {
    id: 'cssbuy-review',
    titleKey: 'article_review_title',
    descKey: 'article_review_desc',
    category: 'Review',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=five%20star%20rating%20and%20review%20cards%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light%20minimal&width=600&height=400&seq=art-review&orientation=landscape',
  },
  {
    id: 'cssbuy-shipping',
    titleKey: 'article_shipping_title',
    descKey: 'article_shipping_desc',
    category: 'Shipping',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=cardboard%20shipping%20boxes%20with%20tracking%20labels%20stacked%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light&width=600&height=400&seq=art-shipping&orientation=landscape',
  },
  {
    id: 'cssbuy-warehouse',
    titleKey: 'article_warehouse_title',
    descKey: 'article_warehouse_desc',
    category: 'Warehouse',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=neatly%20organized%20modern%20warehouse%20shelves%20with%20labeled%20boxes%20soft%20industrial%20lighting%20minimal%20aesthetic&width=600&height=400&seq=art-warehouse&orientation=landscape',
  },
  {
    id: 'cssbuy-coupon',
    titleKey: 'article_coupon_title',
    descKey: 'article_coupon_desc',
    category: 'Coupon',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=gift%20card%20and%20discount%20coupon%20tickets%20on%20clean%20light%20surface%20studio%20product%20photography%20soft%20light%20minimal&width=600&height=400&seq=art-coupon&orientation=landscape',
  },
  {
    id: 'cssbuy-qc-guide',
    titleKey: 'article_qc_title',
    descKey: 'article_qc_desc',
    category: 'QC',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=magnifying%20glass%20over%20product%20detail%20photos%20on%20clean%20light%20desk%20studio%20photography%20soft%20natural%20light%20minimal&width=600&height=400&seq=art-qc&orientation=landscape',
  },
  {
    id: 'cssbuy-discount-code',
    titleKey: 'article_discount_code_title',
    descKey: 'article_discount_code_desc',
    category: 'Discount',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=laptop%20showing%20discount%20code%20promo%20banner%20on%20clean%20desk%20soft%20natural%20light%20minimal%20editorial&width=600&height=400&seq=art-discount&orientation=landscape',
  },
  {
    id: 'cssbuy-legit',
    titleKey: 'article_legit_title',
    descKey: 'article_legit_desc',
    category: 'Trust',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=secure%20checkmark%20and%20shield%20symbol%20concept%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light%20minimal&width=600&height=400&seq=art-legit&orientation=landscape',
  },
  {
    id: 'cssbuy-shipping-cost',
    titleKey: 'article_shipping_cost_title',
    descKey: 'article_shipping_cost_desc',
    category: 'Shipping',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=calculator%20and%20international%20shipping%20labels%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light%20minimal&width=600&height=400&seq=art-shipping-cost&orientation=landscape',
  },
  {
    id: 'cssbuy-w2c',
    titleKey: 'article_w2c_title',
    descKey: 'article_w2c_desc',
    category: 'Guide',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=smartphone%20showing%20product%20link%20with%20shopping%20cart%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light&width=600&height=400&seq=art-w2c&orientation=landscape',
  },
  {
    id: 'cssbuy-beginner',
    titleKey: 'article_beginner_title',
    descKey: 'article_beginner_desc',
    category: 'Beginner',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=first%20step%20concept%20staircase%20of%20boxes%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20natural%20light%20minimal&width=600&height=400&seq=art-beginner&orientation=landscape',
  },
  {
    id: 'cssbuy-comparison',
    titleKey: 'article_comparison_title',
    descKey: 'article_comparison_desc',
    category: 'Comparison',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=two%20product%20cards%20side%20by%20side%20comparison%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light%20minimal&width=600&height=400&seq=art-comparison&orientation=landscape',
  },
  {
    id: 'cssbuy-spreadsheet-links',
    titleKey: 'article_spreadsheet_links_title',
    descKey: 'article_spreadsheet_links_desc',
    category: 'Resources',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=chain%20link%20and%20bookmark%20icons%20over%20product%20catalog%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light&width=600&height=400&seq=art-links&orientation=landscape',
  },
  {
    id: 'cssbuy-warehouse-fees',
    titleKey: 'article_warehouse_fees_title',
    descKey: 'article_warehouse_fees_desc',
    category: 'Warehouse',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=price%20tag%20and%20receipt%20on%20shipping%20box%20clean%20light%20background%20studio%20product%20photography%20soft%20natural%20light%20minimal&width=600&height=400&seq=art-warehouse-fees&orientation=landscape',
  },
];